module.exports = require("@testing-library/react");